export const LEGAL_URLS = {
  terms: 'https://prosecaptain.com/regulamin/',
  privacy: 'https://prosecaptain.com/polityka-prywatnosci/',
} as const;
